import { render, staticRenderFns } from "./reportSemesterBaby.vue?vue&type=template&id=15d5bbe2&scoped=true&"
import script from "./reportSemesterBaby.vue?vue&type=script&lang=js&"
export * from "./reportSemesterBaby.vue?vue&type=script&lang=js&"
import style0 from "./reportSemesterBaby.vue?vue&type=style&index=0&id=15d5bbe2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5bbe2",
  null
  
)

component.options.__file = "reportSemesterBaby.vue"
export default component.exports